import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import { useLenisScroll } from './hooks/useLenisScroll';
import PressRelease from './pages/PressRelease';

function App() {
  const { lenis } = useLenisScroll();
  useEffect(() => {
    // Fonction pour gérer le scroll vers l'ancre après la navigation
    const handleHash = () => {
      const hash = window.location.hash;
      if (hash === '#metrics-section') {
        setTimeout(() => {
          const element = document.getElementById('metrics-section');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    };
  
    // Écouter les changements de hash
    window.addEventListener('hashchange', handleHash);
    // Vérifier le hash au chargement initial
    handleHash();
  
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);
  return (
    <Router>
      <div className="page-wrapper">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/press-release" element={<PressRelease />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;